import script from "./RegisterEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterEmail.vue?vue&type=script&setup=true&lang=js"

import "./RegisterEmail.vue?vue&type=style&index=0&id=37613ca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37613ca6"]])

export default __exports__